var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    { attrs: { "max-width": "640" } },
    [
      _c("w-card-title", [
        _vm._v(
          _vm._s(_vm.$ct(_vm.add ? "sidebar.add-block" : "sidebar.edit-block"))
        ),
      ]),
      _c(
        "w-scroll-view",
        { attrs: { tag: "w-card-content" } },
        [
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c("w-input", {
                    attrs: {
                      label: _vm.$ct("sidebar.block-title"),
                      placeholder: _vm.defaultTitle,
                      fancy: "",
                    },
                    model: {
                      value: _vm.block.Title,
                      callback: function ($$v) {
                        _vm.$set(_vm.block, "Title", $$v)
                      },
                      expression: "block.Title",
                    },
                  }),
                ],
                1
              ),
              _vm.block.isFieldsBlock
                ? _c(
                    "w-col",
                    { attrs: { xs: "12" } },
                    [
                      _c("w-select", {
                        attrs: {
                          items: _vm.columnItems,
                          label: _vm.$ct("sidebar.block-columns"),
                          fancy: "",
                        },
                        model: {
                          value: _vm.block.Columns,
                          callback: function ($$v) {
                            _vm.$set(_vm.block, "Columns", $$v)
                          },
                          expression: "block.Columns",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c("w-checkbox", {
                    attrs: { label: _vm.$ct("sidebar.block-collapsed") },
                    model: {
                      value: _vm.block.Collapsed,
                      callback: function ($$v) {
                        _vm.$set(_vm.block, "Collapsed", $$v)
                      },
                      expression: "block.Collapsed",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm.block.isFieldsBlock
            ? [
                _c("h4", { staticClass: "fields-title" }, [
                  _vm._v(_vm._s(_vm.$ct("sidebar.fields"))),
                ]),
                _vm.block.Fields.length == 0
                  ? _c(
                      "w-list-item",
                      [
                        _c("w-list-item-text", { staticClass: "gray" }, [
                          _vm._v(_vm._s(_vm.$ct("sidebar.no-fields"))),
                        ]),
                      ],
                      1
                    )
                  : _c(
                      "w-sortable",
                      {
                        attrs: {
                          items: _vm.block.Fields,
                          "disable-x": "",
                          "keep-in-y": "",
                          tag: "w-list",
                          "target-class": "handle",
                        },
                      },
                      _vm._l(_vm.block.Fields, function (field, i) {
                        return _c(
                          "w-list-item",
                          { key: i, attrs: { "show-handle": "" } },
                          [
                            _c("w-list-item-text", [
                              _c("span", [
                                _vm._v(" " + _vm._s(field.Name) + " "),
                                _c("span", { staticClass: "gray" }, [
                                  _vm._v(
                                    "(" +
                                      _vm._s(_vm.getFieldFriendlyName(field)) +
                                      ")"
                                  ),
                                ]),
                              ]),
                            ]),
                            _c(
                              "w-list-item-action",
                              [
                                _c(
                                  "w-button",
                                  {
                                    directives: [
                                      {
                                        name: "tooltip",
                                        rawName: "v-tooltip",
                                        value: _vm.$ct("sidebar.edit-field"),
                                        expression: "$ct('sidebar.edit-field')",
                                      },
                                    ],
                                    on: {
                                      click: function ($event) {
                                        return _vm.editField(field, i)
                                      },
                                    },
                                  },
                                  [_c("w-fa", { attrs: { icon: "pen" } })],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "w-list-item-action",
                              [
                                _c(
                                  "w-button",
                                  {
                                    directives: [
                                      {
                                        name: "tooltip",
                                        rawName: "v-tooltip",
                                        value: _vm.$ct("sidebar.remove-field"),
                                        expression:
                                          "$ct('sidebar.remove-field')",
                                      },
                                    ],
                                    staticClass: "danger",
                                    on: {
                                      click: function ($event) {
                                        return _vm.removeField(i)
                                      },
                                    },
                                  },
                                  [_c("w-fa", { attrs: { icon: "trash" } })],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      }),
                      1
                    ),
                _c(
                  "w-list-item",
                  {
                    on: {
                      click: function ($event) {
                        return _vm.addField()
                      },
                    },
                  },
                  [
                    _c(
                      "w-list-item-icon",
                      [_c("w-fa", { attrs: { icon: "plus" } })],
                      1
                    ),
                    _c("w-list-item-text", [
                      _vm._v(_vm._s(_vm.$ct("sidebar.add-field"))),
                    ]),
                  ],
                  1
                ),
              ]
            : _vm._e(),
        ],
        2
      ),
      _c(
        "w-card-actions",
        [
          _c(
            "w-button",
            {
              staticClass: "cancel",
              attrs: { icon: "ban" },
              on: {
                click: function ($event) {
                  return _vm.$emit("cancel")
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("common.cancel")))]
          ),
          _c("w-spacer"),
          _c(
            "w-button",
            {
              attrs: { icon: "check" },
              on: {
                click: function ($event) {
                  return _vm.$emit("save")
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("common.confirm")))]
          ),
        ],
        1
      ),
      _vm.editingField && _vm.browse
        ? _c(
            "w-modal",
            { attrs: { value: "" } },
            [
              _c("app-sidebar-field-edit", {
                attrs: {
                  field: _vm.editingField,
                  browse: _vm.browse,
                  add: _vm.editingFieldIndex == -1,
                },
                on: {
                  save: _vm.saveField,
                  cancel: function ($event) {
                    _vm.editingField = null
                  },
                },
              }),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }